// dateUtils.ts - نسخة محسنة للتعامل مع التواريخ من الباك إند
export function formatEgyptDate(dateString: string): string {
    if (!dateString) return 'تاريخ غير متوفر';
    
    try {
        const date = new Date(dateString);
        
        // ✅ التحقق من صحة التاريخ
        if (isNaN(date.getTime())) {
            return dateString;
        }
        
        // ✅ استخدام توقيت مصر (UTC+2)
        const options: Intl.DateTimeFormatOptions = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZone: 'Africa/Cairo',  // ✅ تحديد توقيت مصر صراحة
            hour12: true
        };
        
        return date.toLocaleDateString('ar-EG', options);
    } catch {
        return dateString;
    }
}

export function formatDateOnly(dateString?: string): string {
    if (!dateString) return 'غير محدد';
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return 'غير صالح';
        
        return date.toLocaleDateString('ar-EG', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            timeZone: 'Africa/Cairo'
        });
    } catch {
        return 'غير صالح';
    }
}

// ✅ دالة جديدة لتنسيق الوقت فقط
export function formatTimeOnly(dateString?: string): string {
    if (!dateString) return '';
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '';
        
        return date.toLocaleTimeString('ar-EG', {
            hour: '2-digit',
            minute: '2-digit',
            timeZone: 'Africa/Cairo',
            hour12: true
        });
    } catch {
        return '';
    }
}

// ✅ دالة للتحقق من انتهاء الصلاحية
export function isExpired(expiryDateString?: string): boolean {
    if (!expiryDateString) return false;
    try {
        const expiryDate = new Date(expiryDateString);
        const today = new Date();
        
        // ✅ ضبط كل التواريخ على توقيت مصر للمقارنة
        const expiryInCairo = new Date(expiryDate.toLocaleString('en-US', { timeZone: 'Africa/Cairo' }));
        const todayInCairo = new Date(today.toLocaleString('en-US', { timeZone: 'Africa/Cairo' }));
        
        // ✅ مقارنة التواريخ (بدون وقت)
        expiryInCairo.setHours(0, 0, 0, 0);
        todayInCairo.setHours(0, 0, 0, 0);
        
        return expiryInCairo < todayInCairo;
    } catch {
        return false;
    }
}

// ✅ دالة لحساب الأيام المتبقية حتى انتهاء الصلاحية
export function daysUntilExpiry(expiryDateString?: string): number | null {
    if (!expiryDateString) return null;
    try {
        const expiryDate = new Date(expiryDateString);
        const today = new Date();
        
        // ✅ ضبط كل التواريخ على توقيت مصر
        const expiryInCairo = new Date(expiryDate.toLocaleString('en-US', { timeZone: 'Africa/Cairo' }));
        const todayInCairo = new Date(today.toLocaleString('en-US', { timeZone: 'Africa/Cairo' }));
        
        // ✅ ضبط الساعات للصفر للمقارنة
        expiryInCairo.setHours(0, 0, 0, 0);
        todayInCairo.setHours(0, 0, 0, 0);
        
        const diffTime = expiryInCairo.getTime() - todayInCairo.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        
        return diffDays;
    } catch {
        return null;
    }
}